module.exports = __webpack_public_path__ + "static/media/corn.3975bddd.svg";